import api from '../../../App/socket';

export const editLocationCriteria = (configId, locationCriteriaId, config) => api.send({
    api: 'db',
    model: 'Leadomatic_configuration',
    action: 'NestedUpdate',
    options: {
        where: {
            _id: configId,
        },
        fullPath: `location_criteria.${locationCriteriaId}`,
        update: config,
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/requests/edit_location_criteria.js